/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tag } from '../../models/tag';

export interface ApiMasterTagGetActiveGet$Params {
}

export function apiMasterTagGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterTagGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Tag>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTagGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Tag>>;
    })
  );
}

apiMasterTagGetActiveGet.PATH = '/api/Master/Tag/GetActive';
